import React from 'react';
import {Link} from 'react-router-dom';

function Page404() {
    return (
        <section className="page-404" style={{padding: '120px 0', textAlign: 'center'}}>
            <div className="container">
                <h1 style={{fontSize: '120px', color: 'var(--primary)', marginBottom: '20px'}}>404</h1>
                <h3 style={{marginBottom: '20px'}}>Halaman Tidak Ditemukan</h3>
                <p style={{marginBottom: '30px'}}>Halaman yang Anda cari tidak tersedia.</p>
                <Link to="/" className="btn-action" style={{
                    background: 'var(--primary)',
                    color: '#fff',
                    padding: '12px 32px',
                    borderRadius: '90px',
                    textDecoration: 'none'
                }}>Kembali ke Beranda</Link>
            </div>
        </section>
    );
}

export default Page404;